import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RestService } from '../../services/rest.service';
import Auth from '@aws-amplify/auth';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(
    private auth: AuthService
    , private rest: RestService
    , private router: Router
  ) { }

  public agreed_to_terms = false;

  ngOnInit() {
  }

  logOut() {
    this.auth.removeLocalStorage();
    this.auth.msalLogout();
    
    Auth.signOut()
      .then(data => console.log(data))
      .catch(err => console.log(err));
    return true;
  }

  submit() {
    this.rest.putAgreeToTerms()
      .subscribe((data: any) => {
        if (data.rowCount === 1) {
          this.auth.setAgreeToTerms();
          this.router.navigate(['/home'], {});
        }
      }, (err) => {
        console.log(err);
      });
  }
}
